import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import { FlexGrid, Header } from '@gasbuddy/react-components';
import Card from '../card';
import BpDateRangePicker from '../bp-date-range-picker';
import StationCompetitorsMap from './station-competitors-map';

// import StationPropType from '../../utils/prop-types/station';
// import DateRangePropType from '../../utils/prop-types/date-range';
// import ComparisonMetricPropType from '../../utils/prop-types/comparison-metric';

import styles from './styles.css';

// const { logError } = require('../../../lib/bputils').default;

class CompetitionTabContent extends React.Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    // station: StationPropType,
    // dateRange: DateRangePropType,
    // comparisonMetric: ComparisonMetricPropType,
  }

  static defaultProps = {
    isLoading: false,
    // station: null,
    // dateRange: null,
    // comparisonMetric: null,
  }

  test = () => null

  render() {
    const { isLoading } = this.props;
    return (
      <div className={styles.competitionTab}>
        <div className={styles.filterBar}>
          <div className={styles.filterItem}>
            <div>
              <Header as="h4">
                Date Range
              </Header>
            </div>
            <BpDateRangePicker className={styles.filterComponent} gTagTitle="Competition Tab Date Range Picker" />
          </div>
        </div>

        <FlexGrid container>
          <FlexGrid.Column mobile={12}>
            <Card title="COMPETITIVE LANDSCAPE" isLoading={isLoading}>
              <StationCompetitorsMap />
            </Card>
          </FlexGrid.Column>
        </FlexGrid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  station: state.station,
  dateRange: state.dateRange,
  isLoading: state.loading,
});

export default connect(mapStateToProps, null)(CompetitionTabContent);
